__turbopack_context__.v({
  "filter-footer--mobile": "search-advanced-filter-module-scss-module__SfmQLG__filter-footer--mobile",
  "filter-header": "search-advanced-filter-module-scss-module__SfmQLG__filter-header",
  "filter-header--mobile": "search-advanced-filter-module-scss-module__SfmQLG__filter-header--mobile",
  "form": "search-advanced-filter-module-scss-module__SfmQLG__form",
  "form--mobile": "search-advanced-filter-module-scss-module__SfmQLG__form--mobile",
});
